import { formatDateOnly } from '@peanuds/shared';

import {
  INSTANT_TRANSFER_DATE_LABEL,
  INSTANT_TRANSFER_DATE_LABEL_SCHEMES,
} from './send-money.constants';
import type { SendMoneyDraft, TransferScheme } from './send-money.types';
import { isExternalDraft } from './send-money.utils';

export const toDateOnlyPart = (value: number): string => value.toString().padStart(2, '0');

export const toTodayIsoDate = (): string => {
  const today = new Date();

  return `${today.getFullYear()}-${toDateOnlyPart(today.getMonth() + 1)}-${toDateOnlyPart(today.getDate())}`;
};

const toIsoDateOnly = (value: string): string => value.split('T')[0];

export const toLocalIsoDate = (date: Date): string => {
  return `${date.getFullYear()}-${toDateOnlyPart(date.getMonth() + 1)}-${toDateOnlyPart(date.getDate())}`;
};

export const toLocalDate = (isoDate: string): Date => {
  const [year, month, day] = toIsoDateOnly(isoDate).split('-').map(Number);

  return new Date(year, month - 1, day);
};

export const isInstantTransferDateLabelScheme = (scheme: TransferScheme | null): boolean => {
  return scheme !== null && INSTANT_TRANSFER_DATE_LABEL_SCHEMES.includes(scheme);
};

export const shouldShowInstantTransferDateLabel = (
  draft: SendMoneyDraft,
  transferDate: string | null,
): boolean => {
  if (transferDate === null || toIsoDateOnly(transferDate) !== toTodayIsoDate()) {
    return false;
  }

  return isExternalDraft(draft) && isInstantTransferDateLabelScheme(draft.scheme);
};

export const getTransferDateDisplayValue = (
  draft: SendMoneyDraft,
  transferDate: string | null,
): string | null => {
  if (transferDate === null) {
    return null;
  }

  if (shouldShowInstantTransferDateLabel(draft, transferDate)) {
    return INSTANT_TRANSFER_DATE_LABEL;
  }

  return formatDateOnly(transferDate);
};
